module.exports = __webpack_public_path__ + "static/media/3DPPA10.010e7f17.jpg";